(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  // Populate province selects from the option's data-provinces payload.
  const wireProvinces = (root) => {
    for (const country of root.querySelectorAll('[data-lc-country-select]')) {
      const province = document.getElementById(country.dataset.lcProvinceTarget);
      if (!province) continue;
      const sync = () => {
        const selected = country.options[country.selectedIndex];
        const provinces = JSON.parse(selected?.dataset.provinces || '[]');
        const wrap = province.closest('.lc-field');
        province.innerHTML = '';
        if (provinces.length === 0) {
          if (wrap) wrap.hidden = true;
          return;
        }
        if (wrap) wrap.hidden = false;
        for (const [value, label] of provinces) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          if (value === province.dataset.default) option.selected = true;
          province.append(option);
        }
      };
      if (country.dataset.default) country.value = country.dataset.default;
      country.addEventListener('change', sync);
      sync();
    }
  };
  wireProvinces(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Grid / list view toggle, persisted.
  const applyView = (view) => {
    const grid = document.querySelector('[data-lc-collection-grid]');
    if (!grid) return;
    grid.classList.toggle('lc-collection__grid--list', view === 'list');
    for (const button of document.querySelectorAll('[data-lc-view]')) {
      button.setAttribute('aria-pressed', String(button.dataset.lcView === view));
    }
  };

  try {
    applyView(localStorage.getItem('lc:collection-view') || 'grid');
  } catch { /* storage unavailable */ }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-lc-view]');
    if (toggle) {
      applyView(toggle.dataset.lcView);
      try { localStorage.setItem('lc:collection-view', toggle.dataset.lcView); } catch { /* ignore */ }
    }
  });

  // Progressive "load more": fetch next page, append cards, swap button.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lc-load-more]');
    if (!button) return;
    event.preventDefault();
    button.setAttribute('data-loading', '');
    try {
      const response = await fetch(button.href);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const dom = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = document.querySelector('[data-lc-collection-grid]');
      const nextGrid = dom.querySelector('[data-lc-collection-grid]');
      if (grid && nextGrid) {
        grid.append(...nextGrid.children);
      }
      const nextButton = dom.querySelector('[data-lc-load-more]');
      const wrap = button.closest('.lc-collection__load-more');
      const nextWrap = dom.querySelector('.lc-collection__load-more');
      if (nextButton && nextWrap) {
        wrap?.replaceWith(nextWrap);
      } else {
        wrap?.remove();
      }
    } catch {
      location.assign(button.href);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Native share with clipboard fallback.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lc-share]');
    if (!button) return;
    const payload = { title: document.title, url: location.href };
    if (navigator.share) {
      try { await navigator.share(payload); } catch { /* user dismissed */ }
      return;
    }
    try {
      await navigator.clipboard.writeText(location.href);
      const label = button.querySelector('.lc-button__label');
      if (label) {
        const original = label.textContent;
        label.textContent = button.dataset.shareCopied;
        setTimeout(() => { label.textContent = original; }, 2000);
      }
    } catch { /* clipboard unavailable */ }
  });

  // Custom Element for Volume Discount Selection
  class LcVolumeDiscount extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onSelect.bind(this));
    }

    onSelect() {
      const qty = parseInt(this.getAttribute('data-qty') || '1', 10);
      const discount = this.getAttribute('data-discount') || '';
      
      const form = this.closest('.lc-product__info')?.querySelector('lc-product-form form') || document.querySelector('lc-product-form form');
      if (!form) return;

      const isCurrentlyActive = this.classList.contains('is-active');

      document.querySelectorAll('lc-volume-discount').forEach(el => {
        el.classList.remove('is-active');
      });

      const qtyInput = form.querySelector('[name="quantity"]');
      let discInput = form.querySelector('.lc-vd-discount-input');

      if (isCurrentlyActive) {
        if (qtyInput) {
          qtyInput.value = 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (discInput) discInput.remove();
      } else {
        this.classList.add('is-active');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (discount) {
          if (!discInput) {
            discInput = document.createElement('input');
            discInput.type = 'hidden';
            discInput.name = 'discount';
            discInput.className = 'lc-vd-discount-input';
            form.appendChild(discInput);
          }
          discInput.value = discount;
        } else if (discInput) {
          discInput.remove();
        }
      }
    }
  }

  if (!customElements.get('lc-volume-discount')) {
    customElements.define('lc-volume-discount', LcVolumeDiscount);
  }

  // Custom Element for Flexible Multi-Tier Offer Selector (Supports 1, 2, or 3 tiers)
  class LcOfferSelector extends HTMLElement {
    constructor() {
      super();
      this.timerInterval = null;
      this.currentVariant = null;
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-tier-card]'));
      this.enabledCount = parseInt(this.getAttribute('data-enabled-count') || this.cards.length, 10);
      this.defaultTier = this.getAttribute('data-default-tier') || 'none';

      this.cards.forEach(card => {
        card.addEventListener('click', () => this.handleCardClick(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleCardClick(card);
          }
        });
      });

      this.initTimer();

      this._onVariantBound = this.onVariantChange.bind(this);
      document.addEventListener('lc:variant:change', this._onVariantBound);

      // Listen for manual quantity input changes to keep offer cards in sync
      const form = this.closest('.lc-product__info')?.querySelector('lc-product-form form') || document.querySelector('lc-product-form form');
      if (form) {
        const qtyInput = form.querySelector('[name="quantity"]');
        if (qtyInput) {
          this._onQtyBound = () => {
            const currentVal = parseInt(qtyInput.value, 10);
            this.syncCardsWithQuantity(currentVal);
          };
          qtyInput.addEventListener('change', this._onQtyBound);
        }
      }

      const activeCard = this.cards.find(c => c.classList.contains('is-active'));
      if (activeCard) {
        const qty = parseInt(activeCard.getAttribute('data-qty') || '4', 10);
        const freeQty = parseInt(activeCard.getAttribute('data-free-qty') || '0', 10);
        const paidQty = parseInt(activeCard.getAttribute('data-paid-qty') || (qty - freeQty), 10);
        this.updateFormQuantity(paidQty, freeQty);
      }
    }

    syncCardsWithQuantity(qty) {
      const matchedCard = this.cards.find(c => {
        const cardPaid = parseInt(c.getAttribute('data-paid-qty') || c.getAttribute('data-qty') || '0', 10);
        return cardPaid === qty;
      });
      this.cards.forEach(c => {
        const isMatch = (c === matchedCard);
        c.classList.toggle('is-active', isMatch);
        c.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });
      const form = this.closest('.lc-product__info')?.querySelector('lc-product-form form') || document.querySelector('lc-product-form form');
      if (form) {
        const freeQty = matchedCard ? parseInt(matchedCard.getAttribute('data-free-qty') || '0', 10) : 0;
        let freeInput = form.querySelector('input[name="_free_qty"]');
        if (freeQty > 0) {
          if (!freeInput) {
            freeInput = document.createElement('input');
            freeInput.type = 'hidden';
            freeInput.name = '_free_qty';
            form.appendChild(freeInput);
          }
          freeInput.value = freeQty;
        } else if (freeInput) {
          freeInput.remove();
        }
      }
    }

    handleCardClick(card) {
      const wasActive = card.classList.contains('is-active');
      if (wasActive) {
        this.cards.forEach(c => {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        this.updateFormQuantity(1, 0);
      } else {
        this.cards.forEach(c => {
          const isMatch = (c === card);
          c.classList.toggle('is-active', isMatch);
          c.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
        });
        const qty = parseInt(card.getAttribute('data-qty') || '1', 10);
        const freeQty = parseInt(card.getAttribute('data-free-qty') || '0', 10);
        const paidQty = parseInt(card.getAttribute('data-paid-qty') || (qty - freeQty), 10);
        this.updateFormQuantity(paidQty, freeQty);
      }
    }

    updateFormQuantity(paidQty, freeQty = 0) {
      const form = this.closest('.lc-product__info')?.querySelector('lc-product-form form') || document.querySelector('lc-product-form form');
      if (form) {
        const qtyInput = form.querySelector('[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = paidQty;
        }

        let freeInput = form.querySelector('input[name="_free_qty"]');
        if (freeQty > 0) {
          if (!freeInput) {
            freeInput = document.createElement('input');
            freeInput.type = 'hidden';
            freeInput.name = '_free_qty';
            form.appendChild(freeInput);
          }
          freeInput.value = freeQty;
        } else if (freeInput) {
          freeInput.remove();
        }
      }
    }

    onVariantChange(e) {
      const variant = e.detail?.variant;
      if (!variant) return;
      this.currentVariant = variant;

      const singlePrice = variant.price;
      const singleCompare = (variant.compare_at_price && variant.compare_at_price > singlePrice)
        ? variant.compare_at_price
        : singlePrice;

      this.cards.forEach(card => {
        const qty = parseInt(card.getAttribute('data-qty') || '1', 10);
        const freeQty = parseInt(card.getAttribute('data-free-qty') || '0', 10);
        const paidQty = parseInt(card.getAttribute('data-paid-qty') || (qty - freeQty), 10);
        const discountPct = parseFloat(card.getAttribute('data-discount-pct') || '0');

        let total, compare, unitPrice, savings;
        if (freeQty > 0) {
          total = singlePrice * paidQty;
          compare = singleCompare * qty;
          if (compare <= total) {
            compare = singlePrice * qty;
          }
          savings = compare - total;
          unitPrice = Math.round(total / qty);
        } else {
          const multiplier = (100 - discountPct) / 100;
          unitPrice = Math.round(singleCompare * multiplier);
          total = unitPrice * qty;
          compare = singleCompare * qty;
          savings = compare - total;
        }

        const priceEl = card.querySelector('[data-lc-price]');
        const compareEl = card.querySelector('[data-lc-compare]');
        const saveEl = card.querySelector('[data-lc-save-amount]');
        const unitEl = card.querySelector('[data-lc-unit-price]');

        if (priceEl) priceEl.textContent = this.formatMoney(total);
        if (compareEl) compareEl.textContent = this.formatMoney(compare);
        if (saveEl) saveEl.textContent = this.formatMoney(savings);
        if (unitEl) unitEl.textContent = this.formatMoney(unitPrice);
      });
    }

    formatMoney(cents) {
      if (window.LcPromotionUtils && window.LcPromotionUtils.formatMoney) {
        return window.LcPromotionUtils.formatMoney(cents);
      }
      const moneyFormat = window.LcSettings?.moneyFormat || 'Rs. {{amount}}';
      const amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2 }))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }

    initTimer() {
      const timerDisplay = this.querySelector('[data-lc-timer-display]');
      if (!timerDisplay) return;

      let remainingSeconds = 14 * 60 + 27;
      const storedExpiry = sessionStorage.getItem('lc_offer_timer_expiry');
      const now = Date.now();

      if (storedExpiry && parseInt(storedExpiry, 10) > now) {
        remainingSeconds = Math.floor((parseInt(storedExpiry, 10) - now) / 1000);
      } else {
        sessionStorage.setItem('lc_offer_timer_expiry', (now + remainingSeconds * 1000).toString());
      }

      const updateTimer = () => {
        if (remainingSeconds <= 0) {
          remainingSeconds = 15 * 60;
          sessionStorage.setItem('lc_offer_timer_expiry', (Date.now() + remainingSeconds * 1000).toString());
        }
        const mins = Math.floor(remainingSeconds / 60);
        const secs = remainingSeconds % 60;
        timerDisplay.textContent = `${String(mins).padStart(2, '0')} : ${String(secs).padStart(2, '0')}`;
        remainingSeconds--;
      };

      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1000);
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
      if (this._onVariantBound) {
        document.removeEventListener('lc:variant:change', this._onVariantBound);
      }
      if (this._onQtyBound) {
        const form = this.closest('.lc-product__info')?.querySelector('lc-product-form form') || document.querySelector('lc-product-form form');
        const qtyInput = form?.querySelector('[name="quantity"]');
        if (qtyInput) qtyInput.removeEventListener('change', this._onQtyBound);
      }
    }
  }

  if (!customElements.get('lc-offer-selector')) {
    customElements.define('lc-offer-selector', LcOfferSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  // Fetch server-computed recommendations and swap this section in place.
  class LcRecommendations extends HTMLElement {
    async connectedCallback() {
      if (this.hasAttribute('data-performed')) return;
      const sectionEl = this.closest('.shopify-section');
      const { sectionId, productId } = this.dataset;
      if (!sectionId || !productId || !sectionEl) return;
      try {
        const url = new URL(`${window.Shopify?.routes?.root || '/'}recommendations/products`, location.origin);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('product_id', productId);
        url.searchParams.set('intent', 'related');
        url.searchParams.set('limit', this.getAttribute('data-limit') || '4');
        const response = await fetch(url);
        if (!response.ok) return;
        const dom = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = dom.querySelector('lc-recommendations');
        if (fresh?.querySelector('.lc-product-card')) {
          this.replaceWith(fresh);
        } else {
          sectionEl.remove();
        }
      } catch { /* leave skeletons out of the way */
        sectionEl.remove();
      }
    }
  }
  if (!customElements.get('lc-recommendations')) {
    customElements.define('lc-recommendations', LcRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  // Fill the "recent searches" chips from localStorage when the drawer opens.
  document.addEventListener('lc:drawer:open', (event) => {
    if (event.detail?.id !== 'lc-search-drawer') return;
    const wrap = document.querySelector('[data-lc-recent-searches]');
    const list = document.querySelector('[data-lc-recent-list]');
    if (!wrap || !list) return;
    let recent = [];
    try {
      recent = JSON.parse(localStorage.getItem('lc:recent-searches') || '[]');
    } catch {
      /* storage unavailable */
    }
    if (recent.length === 0) return;
    list.innerHTML = '';
    for (const term of recent) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'lc-chip';
      a.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(term)}`;
      a.textContent = term;
      li.append(a);
      list.append(li);
    }
    wrap.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  // Swap poster for the embed only after an explicit play tap (privacy + perf).
  class LcExternalVideo extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', () => this.#embed());
    }

    #embed() {
      const id = this.dataset.videoId;
      const src = this.dataset.provider === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = this.closest('section')?.querySelector('h2')?.textContent || 'Video';
      this.replaceChildren(iframe);
    }
  }
  if (!customElements.get('lc-external-video')) {
    customElements.define('lc-external-video', LcExternalVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
